var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMute3 = function SvgMute3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "#fff",
    stroke: "#fff",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5H0v6h4l5 4V1zM15.9 5.6l-.8-.7-2.3 2.4-2.4-2.4-.8.7L12 8l-2.4 2.4.8.7 2.4-2.4 2.3 2.4.8-.7L13.5 8z"
  }))));
};
export default SvgMute3;